<template>
  <div>
    <w-title-bar title="意见反馈" textColor="#000000"></w-title-bar>
    <div id="content" class="about_background content">
      <el-card class="content-position no-padding">
        <div class="clearfix header">
          <img class="my_head_background" src="static/product_head.png" />
          <img class="my_head" src="static/feedback_title.png" />
          <span>意见反馈</span>
        </div>
        <div>联系方式</div>
        <el-input
          v-model="number"
          placeholder="请输入邮箱"
          style="margin-top: 10px"
          :rows="1"
          type="email"
        ></el-input>
        <div style="margin-top: 20px">反馈内容</div>
        <el-input
          type="textarea"
          v-model="content"
          placeholder="请输入反馈内容"
          :rows="8"
          style="margin-top: 10px"
        ></el-input>
      </el-card>
      <button class="buttonback" @click="openNfc">提交</button>
    </div>
  </div>
</template>

<script>
import wTitleBar from "@/components/w-titleBar";
export default {
  name: "feedback",
  components: {
    wTitleBar,
  },
  data() {
    return {
      number: "",
      content: "",
    };
  },
  mounted() {
    let divContent = document.getElementById("content").clientHeight;
    let screenHeight = document.body.clientHeight;
    document.getElementById("content").style.cssText =
      "height: " + (divContent - 44) + "px;";
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style>
.about_background {
  background-color: #f6f6f6;
}
.content {
  width: 100vw;
  height: 100vh;
  overflow: scroll;
}
.success_top {
  width: 100vw;
}
.success_center {
  width: 100vw;
  margin-top: -50%;
}
.text-pass {
  margin-top: -44%;
  text-align: center;
  font-size: 20px;
  font-family: PingFang;
  font-weight: 500;
  color: rgba(43, 27, 2, 1);
  line-height: 56px;
}
.text-test {
  font-size: 15px;
  text-align: center;
  font-family: PingFang;
  font-weight: 500;
  color: rgba(208, 2, 27, 1);
  line-height: 37px;
}
.picture-position {
  margin-top: 18%;
  margin-left: 10px;
  margin-right: 10px;
  height: 250px;
  border-radius: 20px;
}
.image {
  width: 100%;
  display: block;
}
.content-position {
  margin-top: 2%;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;
}
.my_head {
  width: 1.2rem;
  height: 1.2rem;
  margin-right: 5px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
  margin-left: -240px;
}
.my_head_background {
  margin-left: -20px;
  height: 2.2rem;
  margin-right: 5px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}
.header {
  padding: 10px 0px;
  box-sizing: border-box;
  margin-top: -10px;
}
.no-padding {
  padding: 0px;
}
.el-carousel__item img {
  height: 200px;
  clear: both;
  display: block;
  margin: auto;
}
.my_center_circle {
  height: 12rem;
  transform: translate(29%, 3%);
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}
.buttonback {
  position: absolute;
  top: 84%;
  width: 95%;
  height: 45px;
  background: url(/static/buttonback.png) no-repeat;
  background-size: 100% 100%;
  border-style: none;
  transform: translate(2.5%, 0%);
  font-family: PingFang;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/feedback.vue